export default function PHP_dump_debug_info() {
  return (
    <div>
      <h1>PHP_dump_debug_info</h1>
    </div>
  );
}
